import cookies from 'js-cookie';

export const getCookieValue = (cookieName: string) => {
  return cookies.get(cookieName);
};

export const setCookieValue = (cookieName: string, cookieValue: string) => {
  return cookies.set(cookieName, cookieValue);
};
